import { kea } from 'kea'
import railsContext from 'lib/selectors/rails-context'
import routes from '~/scenes/routes'

export default kea({
  connect: () => ({
    values: [railsContext, ['scene', 'languageUrl']]
  }),
  actions: () => ({
    setScene: (scene, params) => ({ scene, params })
  }),
  reducers: ({ actions, selectors }) => ({
    scene: [
      selectors.scene,
      {
        [actions.setScene]: (_, payload) => payload.scene
      }
    ],
    params: [
      {},
      {
        [actions.setScene]: (_, payload) => payload.params || {}
      }
    ]
  }),
  urlToAction: ({ actions }) => {
    const mapping = {}
    for (const [paths, scene] of Object.entries(routes)) {
      for (const path of paths.split('|')) {
        mapping[path] = params => actions.setScene(scene, params)
      }
    }

    return mapping
  }
})
